import {
  gql 
} from "@apollo/client";
export const GET_COLORCHART = gql`
    query getColorChart {
      getColorChart {
        id
        title
        description
        pic
        link_text_1
        link_1
        link_text_2
        link_2
        link_text_3
        link_3
        position
        colors{
          id
          title
          rgb
          pic
          position
        }
      }
    }`;
export default {
  GetColorChart: GET_COLORCHART
};
